<template>
  <div class="smartphone-categories" :class="{ 'hide-title': hideTitle }">
    <h2 v-if="!hideTitle">Меню</h2>
    <div class="categories-grid">
      <router-link
        v-for="category in categories"
        :to="{ name: 'MenuCategory', params: { category: category.slug } }"
        :key="category.id"
        @click.native="$emit('clickCategory')"
        active-class="active"
      >
        <div class="icon" :style="{'background-image': `url('${category.acf.icon}')`}"></div>
        <span>{{ category.title.rendered }}</span>
      </router-link>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'SmartphoneCategories',
    props: {
      hideTitle: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapGetters({
        categories: 'menu/categories'
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/blocks/SmartphoneCategories.vue